'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const NonReentrantCommand=require('../../../dist-es6/client/angularCommon/nonReentrantCommand');
const ModalSubmissionResult=require('../../../dist-es6/client/angularCommon/modalSubmissionResult');let

ModalSubmissionCommand=function(){
function ModalSubmissionCommand(modalInstance,submissionAction,$timeout,rx){_classCallCheck(this,ModalSubmissionCommand);
this._modalInstance=modalInstance;
this._submissionAction=submissionAction;
this._completed=!1;
this._nonReentrantCommand=new NonReentrantCommand(this._doIt.bind(this),$timeout,rx);
this._execute=this._nonReentrantCommand.execute.bind(this._nonReentrantCommand);
}ModalSubmissionCommand.prototype.

_doIt=function(){var ref=_asyncToGenerator(function*(){
if(this._completed){
return;
}

let submissionResult=yield this._submissionAction();
_.ensureInstanceOf(ModalSubmissionResult,submissionResult);

if(submissionResult.type==='KeepOpen'){
return;
}

this._completed=!0;

switch(submissionResult.type){
case'Abandon':
break;

case'Close':
this._modalInstance.close(submissionResult.result);
break;

case'Dismiss':
this._modalInstance.dismiss(submissionResult.reason);
break;

default:
throw new Error('bad ModalSubmissionResult type');}


});function _doIt(){return ref.apply(this,arguments)}return _doIt}();_createClass(ModalSubmissionCommand,[{key:'execute',get:function()

{
return this._execute;
}},{key:'inProgress',get:function()

{
return this._nonReentrantCommand.inProgress;
}},{key:'completed',get:function()

{
return this._completed;
}}]);return ModalSubmissionCommand}();


module.exports=ModalSubmissionCommand;
//# sourceMappingURL=modalSubmissionCommand.js.map
